import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, } from '@angular/common/http';
import { URLSearchParams } from "@angular/http";
import { RequestOptions } from '@angular/http';
import { HttpHeaders, HttpParams } from "@angular/common/http"
import { Observable } from "rxjs/Observable";
import { Constants } from './constants';

@Injectable()
export class RequestMethodsService {

    constructor(private http: HttpClient, private constants: Constants) {

    }

    get(token: string, baseUri: string, resourceUri?: string, paramObject?: any): Observable<any> {
        let uri = baseUri
        if (resourceUri){
            uri += resourceUri;
        } 
        let params;
        let ENTITY_API_HEADERS = {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': 'Bearer ' + token,
            'Org': 'connectedequipment.uat'
        }
        let headers = new HttpHeaders(ENTITY_API_HEADERS);
        if (paramObject && JSON.stringify(paramObject) != '{}') {
            params = new HttpParams({
                fromObject: paramObject
            })
        }
        return this.http.get(uri, {
            headers: headers,
            params: params
        });
    }

    post(token: string, uri: string, body: any): Observable<any> {
        let ENTITY_API_HEADERS = {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': 'Bearer ' + token,
            'Org': 'connectedequipment.uat'
        }
        let headers = new HttpHeaders(ENTITY_API_HEADERS);
        return this.http.post(uri, body, { headers: headers });
    }

    put(uri: string, body: any): Observable<any> {
        let header = new HttpHeaders({ 'Content-Type': 'application/json; charset=UTF-8', 'Accept': 'application/json' });
        return this.http.put(uri, body, { headers: header });

    }

    delete(uri: string, body: any): Observable<any> {
        let header = new HttpHeaders({ 'Content-Type': 'application/json; charset=UTF-8', 'Accept': 'application/json' });
        return this.http.delete(uri, body);

    }

    saveLogReportsToDB(token: string, baseuri: string, resourceUri: string, paramObject: any){
        let uri = baseuri + resourceUri
        let params;
        let ENTITY_API_HEADERS = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,
            'Org': 'connectedequipment.uat'
        }
        let headers = new HttpHeaders(ENTITY_API_HEADERS);
        if (paramObject && JSON.stringify(paramObject) != '{}') {
            params = new HttpParams({
                fromObject: paramObject
            })
        }
        return this.http.post(uri, [], { 
            headers: headers,
            params: params
         });
    }

}


// WEBPACK FOOTER //
// ./src/commons/request_methods.ts